import extendFunctions from '@/views/Report/ReportEditor/js/extend.js'
import formatConverter from '@/views/Report/ReportEditor/js/formatConverter.js'
import largeFile from '@/views/Report/ReportEditor/js/largeFile.js'
import alasql from 'alasql'
import { getSystemVariables } from '@/api/dataSpec.js'

export default {
  reportEditor: {},
  printObjectList: [],
  paperOption: {
    author: 'Workfine',
    creator: 'Workfine',
    emptyCells: true, // 属性意义未知，默认给True
    fitWidth: true, // 按列缩放
    guideColor: '#aaa', // 框线颜色
    guidelines: false, // 打印框线
    hCenter: true, // 水平居中
    vCenter: true, // 垂直居中
    headerRows: null, // 页眉行
    landscape: true, // 纸张方向，true=横向，false=纵向
    margin: 'Normal', // 页边距
    customMargin: { // 自定义页边距
      top: 10,
      bottom: 10,
      left: 10,
      right: 10
    },
    maxEmpty: 0.2, // 属性意义未知
    paperSize: 'A4', // 纸张大小
    customPaperSize: {
      height: 297,
      width: 210
    },
    printCount: 1, // 打印数量
    name: 'Sheet1', // 打印对象
    printType: 0, // 打印类型
    scale: 1 // 缩放，受fitWidth影响
  },
  // 导出PDF实现
  ExportPdfFile(reportEditor) {
    this.reportEditor = reportEditor
    this.createPDF(reportEditor.templateAttribute.pdfOption, 'export')
  },

  // 导出Excel文件
  OutputXlsxFile(reportEditor) {
    // reportEditor.spreadSheet.saveAsExcel({ fileName: reportEditor.templateAttribute.name + '.xlsx' })
    reportEditor.spreadSheet.exportAsExcel({ fileName: reportEditor.templateAttribute.name + '.xlsx' })
  },

  // 处理打印按钮逻辑
  async handlePrintReport(reportEditor, sheetGuid, model, content) {
    this.reportEditor = reportEditor
    if (this.printObjectList.find(sheet => sheet.guid === sheetGuid)) {
      await this.createPDF(this.printObjectList.find(sheet => sheet.guid === sheetGuid), model, content !== undefined, content)
    } else {
      extendFunctions.errorMessage('请先设置打印区域再进行下一步操作！', new Error('请先设置打印区域再进行下一步操作！'))
    }
  },

  convertMargin(options) {
    switch (options.margin) {
      case 'custom':
        options.margin = {
          left: options.customMargin.left + 'mm',
          right: options.customMargin.right + 'mm',
          top: options.customMargin.top + 'mm',
          bottom: options.customMargin.bottom + 'mm'
        }
        break
      case 'Normal':
        options.margin = {
          left: '17.8mm',
          right: '17.8mm',
          top: '19.1mm',
          bottom: '19.1mm'
        }
        break
      case 'Wide':
        options.margin = {
          left: '25.4mm',
          right: '25.4mm',
          top: '25.4mm',
          bottom: '25.4mm'
        }
        break
      case 'Narrow':
        options.margin = {
          left: '6.4mm',
          right: '6.4mm',
          top: '19.1mm',
          bottom: '19.1mm'
        }
        break
      case 'Null':
        options.margin = {
          left: '0mm',
          right: '0mm',
          top: '0mm',
          bottom: '0mm'
        }
        break
    }
  },

  // 转换setting为PDF参数
  async createPDF(settingProperty, model, exportFile, content) {
    console.log('开始生成')
    var reportEditor = this.reportEditor
    var that = this
    var sheetParts = []
    var handleSheet
    kendo.reportEditor = reportEditor
    if (model === 'export') {
      // 效率提高方法：先找出有效区域，然后打印
      handleSheet = this.reportEditor.spreadSheet.activeSheet()
      var usedInfo = { maxUsedRow: this.reportEditor.maxUsedRow[handleSheet.name()], maxUsedColumn: this.reportEditor.maxUsedColumn[handleSheet.name()] }
      await reportEditor.spreadSheet._workbook.saveAsPDF({
        area: handleSheet.name().toLowerCase(),
        author: 'workfine',
        creator: 'workfine',
        fitWidth: settingProperty.fitWidth,
        landscape: settingProperty.landscape,
        vCenter: settingProperty.vCenter,
        hCenter: settingProperty.hCenter,
        paperSize: settingProperty.paperSize === 'custom' ? [options.customPaperSize.width + 'mm', options.customPaperSize.height + 'mm'] : settingProperty.paperSize,
        guidelines: false,
        fileName: handleSheet.name(),
        reportEditor,
        usedInfo
      })
      console.log('导出完成')
      handleSheet.showGridLines(!handleSheet.showGridLines())
      handleSheet.showGridLines(!handleSheet.showGridLines())
    } else {
      if (!settingProperty) {
        console.log('空的打印属性')
        return
      }
      // 转换打印属性
      var options = settingProperty.paperOption ? JSON.parse(JSON.stringify(Object.assign({}, this.paperOption, settingProperty.paperOption)))
        : JSON.parse(JSON.stringify(this.paperOption))
      options.reportEditor = reportEditor
      // 纸张大小处理
      if (options.paperSize === 'custom') {
        options.paperSize = [options.customPaperSize.width + 'mm', options.customPaperSize.height + 'mm']
      }
      if (settingProperty.singleColor) {
        options.singleColor = true
      }
      // 边距处理
      this.convertMargin(options)
      options.area = reportEditor.spreadSheet.sheets().find(sheet => sheet.guid === settingProperty.guid).name()
      // 获取打印区域
      var printNameRange
      if (settingProperty.printType === 2) {
        if (settingProperty.linkDataTable) {
          printNameRange = reportEditor.spreadSheet._workbook._names[reportEditor.dataSheets[settingProperty.linkDataTable].areaAlias.toLowerCase()]
          var printTitleRange = new kendo.spreadsheet.RangeRef(
            new kendo.spreadsheet.CellRef(printNameRange.value.topLeft.row - settingProperty.titleCount, printNameRange.value.topLeft.col),
            new kendo.spreadsheet.CellRef(printNameRange.value.topLeft.row, printNameRange.value.bottomRight.col))
          options.area = new kendo.spreadsheet.Range(printTitleRange, reportEditor.spreadSheet.sheetByName(printNameRange.value.sheet))
        } else {
          if (!printNameRange) {
            extendFunctions.errorMessage('请先选择关联扩展表再进行预览！', new Error('请先选择关联扩展表再进行预览！'))
            return
          }
        }
      } else {
        // options.area = this.printProperty.sheets.find(sheet => sheet.guid === this.settingSheet).name
        printNameRange = reportEditor.spreadSheet._workbook._names['printarea_' + options.area.toLowerCase()] ||
          reportEditor.spreadSheet._workbook._names['\'printarea_' + options.area.toLowerCase() + '\'']
        if (!printNameRange) {
          extendFunctions.errorMessage('请先设置打印区域再进行预览！', new Error('请先设置打印区域！'))
          return
        }
      }
      if (settingProperty.titleCount && settingProperty.printExtTitle) {
        var printRangeJson = formatConverter.ConvertAllFormat2Json(printNameRange.value)
        for (var tableId in reportEditor.dataSheets) {
          var tableInfo = reportEditor.dataSheets[tableId]
          if (tableInfo.type + tableInfo.extType === 2) {
            var tableRange = reportEditor.GetNameRangeJson(tableInfo.areaAlias)
            if (reportEditor.RangeOverlaped(printRangeJson, [tableRange])) {
              options.headerEnd = tableRange.topLeft.row - printRangeJson.topLeft.row - 1
              options.headerStart = options.headerEnd - settingProperty.titleCount + 1
              break
            }
          }
        }
      }
      var tableData
      if (settingProperty.printType === 1 || settingProperty.printType === 2) {
        var execExpression = settingProperty.linkTransFilter
        tableData = reportEditor.GetDataFromExtendTable(settingProperty.linkDataTable, null, null, false, true, false, true)
        // 数据筛选
        if (execExpression) {
          // 整理需要使用的字段参数
          var tempStrList = execExpression.match(/\.\[\d+\]/gi)
          var masterFieldParam = { rid: 0 }
          var fieldList = []
          if (tempStrList) {
            tempStrList.forEach(item => {
              fieldList.push(item.match(/\d+/)[0])
            })
            // 取主表数据，做成参数表
            fieldList.forEach(fieldId => {
              if (reportEditor.dataSheets[reportEditor.id2DataSheets[fieldId]].type === 0) {
                masterFieldParam[fieldId] = reportEditor.GetDataFromMasterTable(fieldId)
              }
            })
          }
          tableData.forEach(row => {
            row.rid = 0
          })
          // 替换系统变量
          var variables = (await getSystemVariables()).data
          execExpression = execExpression
            .replace(new RegExp('@s1 ', 'g'), variables[16] + ' ')
            .replace(new RegExp('@s2 ', 'g'), `'${variables[1]}' `)
            .replace(new RegExp('@s3 ', 'g'), `'${variables[2]}' `)
            .replace(new RegExp('@s4 ', 'g'), `'${variables[15]}' `)
            .replace(new RegExp('@s5 ', 'g'), `'${variables[5]}' `)
            .replace(new RegExp('@s6 ', 'g'), variables[6] + ' ')
            .replace(new RegExp('@s7 ', 'g'), `'${variables[17]}' `)
            .replace(new RegExp('@s8 ', 'g'), `'${variables[3]}' `)
            .replace(new RegExp('@s9 ', 'g'), `'${variables[4]}' `)
            .replace(new RegExp('@s10 ', 'g'), `'${variables[18]}' `)
            .replace(new RegExp('@s11 ', 'g'), `'${variables[11]}' `)
            .replace(new RegExp('@s12 ', 'g'), `'${variables[12]}' `)
          // 筛选需要打印的行
          var querySQL = `SELECT * FROM ? [${settingProperty.linkDataTable}] 
              LEFT JOIN ? [${reportEditor.masterTableId}] 
              ON [${settingProperty.linkDataTable}].rid=[${reportEditor.masterTableId}].rid 
              WHERE ${execExpression}`
          console.log(querySQL)
          tableData = alasql(querySQL, [tableData, [masterFieldParam]])
          console.log(tableData)
        }
        if (tableData.length === 0) {
          // 没有筛选出可打印记录
          extendFunctions.errorMessage('没有找到需要打印的记录！')
          return
        }
      }
      var activeSheet = this.reportEditor.spreadSheet.activeSheet()
      this.reportEditor.spreadSheet.activeSheet(this.reportEditor.spreadSheet.sheetByGuid(settingProperty.guid))
      switch (settingProperty.printType) {
        case 0:
          // reportEditor.spreadSheet._workbook.printAsPDF(options).then(() => {
          //   console.log('生成完成')
          // })
          // 打印单页，存放在缓存中
          handleSheet = reportEditor.spreadSheet.sheetByGuid(settingProperty.guid)
          handleSheet.draw(printNameRange.value, options, (group) => {
            sheetParts.push(group)
          })
          break
        case 1:
          var linkInfo = settingProperty.linkNodes.filter(node => node.fromField)
          options.printType = 1
          for (var j = 0; j < tableData.length; j++) {
            if (model === 'preview' && j >= 5) {
              extendFunctions.warningMessage('由于打印内容过多，打印预览默认将只显示前5条记录的打印效果。')
              break
            }
            console.log(`开始绘制第${j}行`)
            // 填入值
            var insertArray = [{}]
            linkInfo.forEach(link => {
              insertArray[0][link.destField] = tableData[j][link.fromField]
            })
            reportEditor.InsertMasterFieldValue(null, insertArray, true)
            // 触发取数公式
            await reportEditor.QueryFormulaHelper(settingProperty.handleFormula)
            // 打印单页，存放在缓存中
            handleSheet = reportEditor.spreadSheet.sheetByGuid(settingProperty.guid)
            handleSheet.draw(printNameRange.value, options, (group) => {
              sheetParts.push(group)
            })
            console.log(`第${j}行绘制完毕`)
          }
          // 导出缓存
          // kendo.drawing.exportPDF(sheetGroup).done((dataURI) => {
          //   if (dataURI) {
          //     if (model === 'preview') {
          //       reportEditor.$refs.printPreview.handlePreviewFile(extendFunctions.getFileURL(extendFunctions.b64toBlob(dataURI.substring(28), 'application/pdf')))
          //     } else {
          //       reportEditor.$refs.printPreview.handlePrintFile(extendFunctions.getFileURL(extendFunctions.b64toBlob(dataURI.substring(28), 'application/pdf')))
          //     }
          //   }
          // })
          break
        case 2:
          // 数据筛选（前置完成）tableData
          // 建立字段=>列的映射关系
          var field2Cell = []
          reportEditor.dataSheets[settingProperty.linkDataTable].children.forEach(fieldInfo => {
            field2Cell.push({
              col: reportEditor.spreadSheet._workbook._names[fieldInfo.areaAlias.toLowerCase()].value.topLeft.col,
              fieldId: fieldInfo.id
            })
          })
          // 初始化输出参数和对象
          var optionsTemp = kendo.jQuery.extend({
            paperSize: 'A4',
            landscape: true,
            margin: '1cm',
            guidelines: true,
            guideColor: '#aaa',
            emptyCells: true,
            fitWidth: false,
            center: false,
            headerRows: null,
            headerStart: null,
            headerEnd: null,
            maxEmpty: 0.2,
            scale: 1
          }, options)
          var group = new kendo.drawing.Group()
          var paper = kendo.pdf.getPaperOptions(optionsTemp)
          group.options.set('pdf', {
            author: optionsTemp.author,
            creator: optionsTemp.creator,
            date: optionsTemp.date,
            keywords: optionsTemp.keywords,
            margin: paper.margin,
            multiPage: true,
            paperSize: paper.paperSize,
            subject: optionsTemp.subject,
            title: optionsTemp.title
          })
          var pageWidth = paper.paperSize[0]
          var pageHeight = paper.paperSize[1]
          if (paper.margin) {
            pageWidth -= paper.margin.left + paper.margin.right + 1
            pageHeight -= paper.margin.top + paper.margin.bottom + 1
          }
          optionsTemp.pageWidth = pageWidth
          optionsTemp.pageHeight = pageHeight
          handleSheet = reportEditor.spreadSheet.sheetByGuid(settingProperty.guid)
          // *创建要绘制的cells集合
          // normalize reference so we don't have to deal with Infinity here.
          var range = options.area
          range.sheet = ''
          // 1. obtain the list of cells that need to be printed, the
          //    row heights and column widths.  Place in each cell row,
          //    col (relative to range, i.e. first is 0,0), rowspan,
          //    colspan and merged.
          var sum = (a, b) => {
            return a + b
          }
          var cells = []
          var rowHeights = []
          var colWidths = []
          var mergedCells = handleSheet._getMergedCells(range)
          var maxRow = -1
          var maxCol = -1
          var titleRowCount = range._ref.bottomRight.row - range._ref.topLeft.row
          var ConvertJsonToA1 = function (JsonStyle) {
            var row = JsonStyle.row + 1
            var column = JsonStyle.col + 1
            var columnStr = ''
            for (; column; column = Math.floor((column - 1) / 26)) {
              columnStr = String.fromCharCode(((column - 1) % 26) + 65) + columnStr
            }
            return columnStr + row
          }
          tableData.forEach((dataRow, index) => {
            handleSheet.forEach(range, (row, col, cell) => {
              var relrow = row - range._ref.topLeft.row
              var relcol = col - range._ref.topLeft.col
              var rh = handleSheet.rowHeight(row)
              var cw = handleSheet.columnWidth(col)
              cell.showZero = handleSheet._defaultCellStyle.showZero
              if (!relcol) {
                rowHeights.push(rh)
              }
              if (!relrow) {
                colWidths.push(cw)
              }
              if (relrow === titleRowCount) {
                // 数据行
                cell.value = dataRow[field2Cell.find(info => info.col === col).fieldId]
                var realCell = handleSheet.range(ConvertJsonToA1({
                  row: index * titleRowCount + relrow + 1,
                  col: col
                }))
                if (cell.barCode) {
                  var info = { id: cell.barCode.barCodeId, value: cell.value }
                  cell.barCode.src = reportEditor.CreateBarCode(info)
                }
                cell.image = realCell.image()
                cell.imageGroup = realCell.imageGroup()
                cell.attachGroup = realCell.attachGroup()
                cell.dataIndex = index
              } else {
                cell.titleIndex = relrow
              }
              if (handleSheet.isHiddenColumn(col) || handleSheet.isHiddenRow(row) || !rh || !cw) {
                // 隐藏行列不打印
                return
              }
              var id = new kendo.spreadsheet.CellRef(row, col).print()
              // 获得最大行列信息
              maxRow += 1
              maxCol = Math.max(maxCol, relcol)
              // 属于合并单元格中被合并部分则不打印
              if (mergedCells.secondary[id]) {
                return
              }
              // 实际行列位置
              cell.realRow = row
              cell.realCol = col
              // 相对行列位置
              cell.row = index * (titleRowCount + 1) + relrow
              cell.col = relcol
              // 合并单元格处理
              var m = mergedCells.primary[id]
              if (m) {
                delete mergedCells.primary[id]
                cell.merged = true
                cell.rowspan = m.height()
                cell.colspan = m.width()
                if (options.forScreen) {
                  cell.width = handleSheet._columns.sum(m.topLeft.col, m.bottomRight.col)
                  cell.height = handleSheet._rows.sum(m.topLeft.row, m.bottomRight.row)
                }
              } else {
                cell.rowspan = 1
                cell.colspan = 1
              }
              cells.push(extendFunctions.deepCopy(cell))
            })
          })
          // console.log(cells)
          // *单元格坐标和高度计算
          // keep only the drawable area
          rowHeights = rowHeights.slice(0, maxRow + 1)
          colWidths = colWidths.slice(0, maxCol + 1)
          pageWidth = optionsTemp.pageWidth
          pageHeight = optionsTemp.pageHeight
          var scaleFactor = optionsTemp.scale || 1

          // when fitWidth is requested, we must update the page size
          // with the corresponding scale factor; the algorithm below
          // (2) will continue to work, just drawing on a bigger page.
          if (optionsTemp.fitWidth) {
            var width = colWidths.reduce(sum, 0)
            if (width > pageWidth) {
              scaleFactor = pageWidth / width
            }
          }
          pageWidth = Math.ceil(pageWidth / scaleFactor)
          pageHeight = Math.ceil(pageHeight / scaleFactor)
          // 2. calculate top, left, bottom, right, width and height for
          //    printable cells.  Merged cells will be split across
          //    pages, unless the first row/col is shifted to next page.
          //    boxWidth and boxHeight get the complete drawing size.
          //    Note that cell coordinates keep increasing, i.e. they
          //    are not reset to zero for a new page.  The print
          //    function translates the view to current page.
          var yCoords = that.distributeCoords(rowHeights, pageHeight || 0, options.maxEmpty)
          var xCoords = that.distributeCoords(colWidths, pageWidth || 0, options.maxEmpty)
          var boxWidth = 0
          var boxHeight = 0
          var headerCells = []
          cells = cells.filter(function (cell) {
            if (cell.empty && (cell.row > maxRow || cell.col > maxCol)) {
              return false
            }
            if (options.headerRows && cell.row < options.headerRows) {
              headerCells.push(cell)
            }
            cell.left = xCoords[cell.col]
            if (options.headerStart != null && cell.row <= options.headerEnd && cell.row >= options.headerStart) {
              // 处理cell的坐标信息
              cell.top = yCoords[cell.row]
              if (options.headerStart > 0) {
                cell.shiftTop = yCoords[cell.row]
              }
              headerCells.push(cell)
            } else {
              cell.top = yCoords[cell.row]
            }
            if (cell.merged) {
              if (!options.forScreen) {
                cell.right = that.orlast(xCoords, cell.col + cell.colspan)
                cell.bottom = that.orlast(yCoords, cell.row + cell.rowspan)
                cell.width = cell.right - cell.left
                cell.height = cell.bottom - cell.top
              } else {
                cell.right = cell.left + cell.width
                cell.bottom = cell.top + cell.height
              }
            } else {
              cell.width = colWidths[cell.col]
              cell.height = rowHeights[cell.row]
              cell.bottom = cell.top + cell.height
              cell.right = cell.left + cell.width
            }
            boxWidth = Math.max(boxWidth, cell.right)
            boxHeight = Math.max(boxHeight, cell.bottom)
            return true
          })

          // 合并单元格处理
          // 3. if any merged cells remain in "primary", they start
          //    outside the printed range and we should still display
          //    them partially.
          Object.keys(mergedCells.primary).forEach(function (id) {
            var ref = mergedCells.primary[id]
            handleSheet.forEach(ref.topLeft.toRangeRef(), function (row, col, cell) {
              var relrow = row - range.topLeft.row
              var relcol = col - range.topLeft.col
              cell.merged = true
              cell.colspan = ref.width()
              cell.rowspan = ref.height()
              if (relrow < 0) {
                cell.top = -handleSheet._rows.sum(row, row - relrow - 1)
              } else {
                cell.top = yCoords[relrow]
              }
              if (relcol < 0) {
                cell.left = -handleSheet._columns.sum(col, col - relcol - 1)
              } else {
                cell.left = xCoords[relcol]
              }
              cell.height = handleSheet._rows.sum(ref.topLeft.row, ref.bottomRight.row)
              cell.width = handleSheet._columns.sum(ref.topLeft.col, ref.bottomRight.col)
              if (cell.height > 0 && cell.width > 0) {
                // zero means a fully hidden merged cell (all rows/columns are hidden)
                // https://github.com/telerik/kendo-ui-core/issues/1794
                cell.right = cell.left + cell.width
                cell.bottom = cell.top + cell.height
                cell.row = relrow
                cell.col = relcol
                cells.push(cell)
              }
            })
          })
          // 组合结果
          reportEditor.spreadSheet.activeSheet().drawLayout(handleSheet, {
            width: boxWidth,
            height: boxHeight,
            cells: cells.sort(that.orderCells),
            scale: scaleFactor,
            xCoords: xCoords,
            yCoords: yCoords
          }, group, optionsTemp)
          sheetParts.push(group)
          break
      }
      var sheetGroup = sheetParts[0]
      for (var i = 1; i < sheetParts.length; ++i) {
        sheetGroup.children = sheetGroup.children.concat(sheetParts[i].children)
      }
      // console.log(sheetGroup)
      // settingProperty.headerFooter = [{
      //   contentType:1,
      //   type:'header',
      //   position:'center',
      //   content:'Page {pageNum} Total {totalNum}',
      //   fontSize:6,
      //   color:'rgb(255,182,193)',
      //   fontFamily:'宋体'
      // },
      // {
      //   contentType:1,
      //   type:'footer',
      //   position:'right',
      //   content:'Page {pageNum} Total {totalNum}',
      //   fontSize:24,
      //   color:'rgb(173,255,47)',
      //   fontFamily:'黑体'
      // }]
      await kendo.drawing.exportPDF(sheetGroup, {}, {
        headerFooter: settingProperty.headerFooter || null,
        reportEditor
      }).done((dataURI) => {
        if (dataURI) {
          if (exportFile) {
            var blobFile = extendFunctions.b64toBlob(dataURI.substring(28), 'application/pdf')
            reportEditor.$set(content.attach, content.attach.length, new File([blobFile], reportEditor.templateAttribute.name + (reportEditor.recordId > 0 ? ('-' + reportEditor.recordId) : '') + '.pdf', { type: 'application/pdf', lastModified: Date.now() }))
          } else {
            if (model === 'preview') {
              reportEditor.$refs.printPreview.handlePreviewFile(extendFunctions.getFileURL(extendFunctions.b64toBlob(dataURI.substring(28), 'application/pdf')))
            } else {
              reportEditor.$refs.printPreview.handlePrintFile(extendFunctions.getFileURL(extendFunctions.b64toBlob(dataURI.substring(28), 'application/pdf')))
            }
          }
        }
        handleSheet.showGridLines(!handleSheet.showGridLines())
        handleSheet.showGridLines(!handleSheet.showGridLines())
      })
      this.reportEditor.spreadSheet.activeSheet(activeSheet)
    }
  },
  distributeCoords(heights, pageHeight, maxEmpty) {
    var curr = 0
    var out = []
    var bottom = pageHeight
    if (pageHeight && maxEmpty) {
      maxEmpty *= pageHeight
    }
    heights.forEach(function (h, i) {
      if (pageHeight && curr + h > bottom) {
        if (bottom - curr < maxEmpty) {
          // align to next page
          curr = pageHeight * Math.ceil(curr / pageHeight)
        }
        // update bottom anyway; don't just add pageHeight, as
        // we might need multiple pages for the pathological
        // case of one row higher than the page.
        bottom += pageHeight * Math.ceil(h / pageHeight)
      }
      out.push(curr)
      curr += h
    })
    out.push(curr)
    return out
  },
  orlast(a, i) {
    return i < a.length ? a[i] : a[a.length - 1]
  },
  orderCells(a, b) {
    if (a.top < b.top) {
      return -1
    } else if (a.top === b.top) {
      if (a.left < b.left) {
        return -1
      } else if (a.left === b.left) {
        return 0
      } else {
        return 1
      }
    } else {
      return 1
    }
  },
  async showBackground(reportEditor) {
    console.log('不生成背景图，与滚动条隐藏功能冲突')
    // return
    // reportEditor.spreadSheet.activeSheet().background = null
    // var sheetGuid = reportEditor.spreadSheet.activeSheet().guid
    // if (reportEditor.printProperty) {
    //   var handleSheet = reportEditor.printProperty.sheets.find(sheet => sheet.guid === sheetGuid)
    //   if (handleSheet) {
    //     if (handleSheet.backgroundImage && handleSheet.backgroundImage.id) {
    //       // 下载图片
    //       largeFile.downloadFile(handleSheet.backgroundImage.id).then(() => {
    //         reportEditor.spreadSheet.sheetByGuid(sheetGuid).background = extendFunctions.getFileURL(largeFile.localImageStorage[handleSheet.backgroundImage.id])
    //       })
    //     }
    //   }
    // }
    // reportEditor.spreadSheet._workbook._view.refresh({})
    var i, sheetGuid, handleSheet
    var sheetsList = reportEditor.spreadSheet.sheets()
    for (i = 0; i < sheetsList.length; i++) {
      sheetsList[i].background = null
      sheetGuid = sheetsList[i].guid
      if (!sheetGuid) {
        continue
      }
      if (reportEditor.printProperty) {
        handleSheet = reportEditor.printProperty.sheets.find(sheet => sheet.guid === sheetGuid)
        if (handleSheet) {
          if (handleSheet.backgroundImage && handleSheet.backgroundImage.id) {
            // 下载图片
            await largeFile.downloadFile(handleSheet.backgroundImage.id)
            sheetsList[i].background = extendFunctions.getFileURL(largeFile.localImageStorage[handleSheet.backgroundImage.id])
          }
        }
      }
    }
    reportEditor.spreadSheet._workbook._view.refresh({})
  },
  updatePrintObjectList(list) {
    list.forEach(item => {
      if (!this.printObjectList.find(obj => obj.guid === item.guid)) {
        this.printObjectList.push(item)
      }
    })
  }
}
